<template>
  <ul v-if="menus.main" class="app-menu-desktop__nav">
    <AppMenuDesktopNavItem
      v-for="item in menus.mainMenu"
      :key="item.id"
      :item="item"
    />
  </ul>
</template>

<script setup lang="ts">
const menus = useMenusStore()
</script>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-menu-desktop__nav {
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}
</style>
